import React from 'react';
import PropTypes from 'prop-types';
import { ResponsivePie } from '@nivo/pie';
import './GraphDonut.scss';

const GraphDonut = ({ title, data, total }) => {

    return (
        <div className="graphdonut-section">
            <div className="graphdonut-content" style={{ height: '170px', width: '200px' }}>
                <ResponsivePie
                    data={data}
                    startAngle={-180}
                    endAngle={180}
                    innerRadius={0.7}
                    padAngle={3}
                    colors={(datum) => datum.data.color} // Updated for color mapping
                    enableArcLabels={false} // `enableSlicesLabels` is now `enableArcLabels`
                    enableArcLinkLabels={false} // `enableRadialLabels` is now `enableArcLinkLabels`
                    animate={true}
                    isInteractive={false}
                />
                <span className="graphdonut-total-container">
                    <span className="graphdonut-total">
                        {total}
                    </span>
                </span>
                <span className="graphdonut-total-label">{title}</span>
            </div>

        </div>
    );

};
GraphDonut.propTypes = {
    title: PropTypes.string,
    data: PropTypes.array.isRequired,
    total: PropTypes.number
};

export default GraphDonut;
